<script lang="ts">
    import { Link } from "svelte-navigator";

    export let active:
        | "general"
        | "organizations";
</script>

<nav class="bg-dark d-md-none">
    <div class="container-md">
        <div class="row align-items-center">
            <div class="col">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <span class="text-white"> Account </span>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                        {#if active == "general"}
                            <span class="text-white"> General </span>
                        {/if}
                        {#if active == "organizations"}
                            <span class="text-white"> Organizations </span>
                        {/if}
                    </li>
                </ol>
            </div>
            <div class="col-auto">
                <div class="navbar-dark">
                    <button
                        class="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#sidenavCollapse"
                        aria-controls="sidenavCollapse"
                        aria-expanded="false"
                        aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</nav>

<div class="col-12 col-md-3">
    <div
        class="card card-bleed border-bottom border-bottom-md-0 shadow-light-lg">
        <div class="collapse d-md-block" id="sidenavCollapse">
            <div class="card-body">
                <h6 class="fw-bold text-uppercase mb-3">Account</h6>

                <ul class="card-list list text-gray-700 mb-6">
                    <li class="list-item {active == 'general' ? 'active' : ''}">
                        <Link class="list-link text-reset" to="/settings"
                            >General</Link>
                    </li>
                    <li
                        class="list-item {active == 'organizations'
                            ? 'active'
                            : ''}">
                        <Link
                            class="list-link text-reset"
                            to="/settings/organizations">Organizations</Link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
